import NodeMessaging from "messaging/NodeMessaging.js";
import {uuid} from 'uuidv4';

export default class CustomZObject extends NodeMessaging(class {}){
    constructor(zobject, setEffect=true) {
        super();
        this.id = uuid();
        this.zObject = zobject;
        if (setEffect) {
            this.zObject.effect = this;
        }
        this.subSequence = zobject.subSequence;
        this.sequencerEngine = this.subSequence.sequencerEngine;
        this.sequencerEngine.idToObject[this.id] = this;

        this.zObject.newAttribute("fill subpatch", false);
    }

    getParameters() { return []; }

    fromJson(json, isCopy) {
        if (!isCopy) {
            this.id = json.id;
            this.sequencerEngine.idToObject[this.id] = this;
        }
    }
    
    getJson() {
        return {
            id: this.id
        };
    }
}
